import { Table, Button, Row, Col, Select } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import React from 'react';
import _ from 'lodash';

const Option = Select.Option;

const ROLES = ['AUTORIZADO', 'PADRE', 'MADRE', 'OTRO', 'GUARDADOR', 'RESPONSABLE'];
class TablaPersonas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      filtered: false,
      visible: false,
    };
  }

  onSelectPersona = (record, value, index) => {
    this.props.cambiarRolPersona(record, value, index);
  };

  render() {
    const columns = [
      {
        title: 'Documento',
        key: 'documento',
        render: persona => persona.tipo_doc + ' ' + persona.num_doc,
      },
      {
        title: 'Nombre',
        key: 'nombre',
        render: persona => persona.apellido + ' ' + persona.nombre,
      },
      {
        title: 'Rol',
        key: 'Rol',
        width: 150,
        render: (record, persona, index) => (
          <Select
            showSearch
            style={{ width: 150 }}
            placeholder="Seleccione el rol"
            optionFilterProp="children"
            value={record.rol ? record.rol : ''}
            onChange={value => this.onSelectPersona(record, value, index)}
            // onSelect={this.onSelectPersona(record)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {_.map(ROLES, rol => {
              return (
                <Option key={rol} value={rol}>
                  {rol}
                </Option>
              );
            })}
          </Select>
        ),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        width: 200,
        render: (text, record) => (
          <span>
            <Button
              size="small"
              type="danger"
              icon={<Icons.EditOutlined />}
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { personas } = this.props;

    const title = () => (
      <Row>
        <Col span={12} offset={6}>
          <h2 style={{ textAlign: 'center' }}> Personas </h2>
        </Col>
        <Col span={6}>
          <Button
            type="primary"
            icon={<Icons.UserOutlined />}
            size="small"
            onClick={() => this.props.cargarPersona()}
          >
            Cargar Persona
          </Button>
        </Col>
      </Row>
    );

    return (
      <div>
        <Table
          rowKey={(record, index) => `${record._id}-${index}`}
          columns={columns}
          pagination={false}
          dataSource={personas}
          title={title}
          locale={{
            emptyText: 'No hay Personas cargadas',
          }}
        />
      </div>
    );
  }
}

export default TablaPersonas;
